import React from 'react'
import ModelViewController from '../../../components/ModelViewController'
import CarouselPageModalController from './CarouselPageModal.controller'
import CarouselPageModalView from './CarouselPageModal.view'

export default function SimpleLandingPage({
  pageData,
  instruction,
  show,
  onClose = null,
  currentCardIndex = 0
}) {
  return (
    <ModelViewController
      view={CarouselPageModalView}
      controller={CarouselPageModalController}
      pageData={pageData}
      instruction={instruction}
      show={show}
      onClose={onClose}
      currentCardIndex={currentCardIndex}
    />
  )
}
